import _ from "lodash"
import { useState, useEffect } from "react";
import { _getNextNewsList } from '@/libraries/common';
import { pageLimit } from '@/config/site';
import { AuthorSection } from '@/components/author';
import { newsTestDriveId } from "../../config/site";
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";


export const VehicleAuthor = (props) => {
    const { t, device, session, params, fetchedData } = props
    const [loading, setLoading] = useState(true)
    // news list
    const [totalRow, setTotalRow] = useState(0);
    const [newsList, setNewsList] = useState([]);
    const [offset, setOffset] = useState(0);
    const [isLoadingNewsList, setIsLoadingNewList] = useState(true)

    useEffect(() => {
        let isMounted = true; // Flag to track component mount status

        const fetchData = async() => {
            try{
                await _getNextNewsList({offset, limit: pageLimit, authorId: params?.vehicle[3], vehicle_model_id: fetchedData?.vehicleData?.vehicle_model_id, activeNewsCategory: [newsTestDriveId[t('lang')]] ?? undefined}, setNewsList, setTotalRow)
            } catch(error) {
                console.log(error)
            } finally {
                if (isMounted) {
                    // Only update state if the component is still mounted
                    setIsLoadingNewList(false)
                    setLoading(false)
                }
            }
        }

        // fetch data
        fetchData();

        return () => {
            isMounted = false; // Mark the component as unmounted
        };
    }, []);

    const _handleLoadMore = async(inView, entry) => {
        if(inView == true && isLoadingNewsList == false){
            setIsLoadingNewList(true)
            await _getNextNewsList({offset: offset + pageLimit, limit: pageLimit, authorId: params?.vehicle[3], vehicle_model_id: fetchedData?.vehicleData?.vehicle_model_id}, setNewsList, setTotalRow)
            setOffset((prev)=>prev + pageLimit)
            setIsLoadingNewList(false)
        }
    }
    return (
        <>
            <AllMeta
                title={t('vehicleBrandModelAuthorDetailPage_meta_title', { brandModel: fetchedData?.vehicleData?.name, author: fetchedData?.authorData?.full_name })}
                description={t('vehicleBrandModelAuthorDetailPage_meta_description', { brand: fetchedData?.vehicleData?.brand_name,  brandModel: fetchedData?.vehicleData?.name, author: fetchedData?.authorData?.full_name })}
                keyword={t('vehicleBrandModelAuthorDetailPage_meta_keyword', { brandModel: fetchedData?.vehicleData?.name, author: fetchedData?.authorData?.full_name})}
                image={!_.isEmpty(fetchedData?.authorData?.profile_image) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.authorData?.profile_image}` : undefined}
                imageWidth={512}
                imageheight={512}
            />
            <Head><title>{t('vehicleBrandModelAuthorDetailPage_title', {brandModel: fetchedData?.vehicleData?.name, author: fetchedData?.authorData?.full_name})}</title></Head>
            <AuthorSection 
                authorData={fetchedData?.authorData}
                newsData={newsList}
                t={t}
                isLoadingNewsList={isLoadingNewsList}
                handleLoadMore={_handleLoadMore}
                pageLimit={pageLimit}
                offset={offset}
                totalRow={totalRow}
                isModelTitle={fetchedData?.vehicleData?.name}
                loading={loading}
            />
        </>
    )
}